// 项目基本设置
import routeMap from './routeMap'
const projectConfig = {
  env: location.host === 'sweb.yunshanmeicai.com' ? 'production' : 'stage',
  routePathName: location.pathname + '#',
  routeMap,
  autoPilot: false
}
export default projectConfig



// WEBPACK FOOTER //
// ./src/tracer/projectConfig.js